import { createContext } from 'react';

const resultadoContext = createContext();

export default resultadoContext;